<template>
  <div class="msgRecords">
    <el-scrollbar style="height:100%" v-if="records.length>0">
      <el-timeline>
        <el-timeline-item
          v-for="(record, index) in records"
          :key="index"
          icon="el-icon-time"
          type="primary"
          size="large"
          placement="top"
          :timestamp="record.createTime"
        >
          <el-row>
            <el-col><span class="remark"><i class="el-icon-chat-line-square"></i> {{ record.content }}</span></el-col>
          </el-row>
        </el-timeline-item>
      </el-timeline>
    </el-scrollbar>
    <div style="height: 100%;text-align: center;line-height: 200px;" v-else>
      <span style="color: dimgrey;">暂无回访信息</span>
    </div>
  </div>
</template>

<script>
import { msgRecord } from "@/api/index";

export default {
  name: "consumRecords",
  props: {
    member: Object
  },
  data() {
    return {
      records: []
    };
  },
  methods: {
  },
  mounted() {
    msgRecord({
      id: this.member.id
    }).then(res => {
      if (res.success == true) {
        this.records = res.result
      } else {
        this.$notify.error({
          title: "错误",
          message: res.message
        });
      }
    });
  }
};
</script>
<style lang="scss">
.msgRecords {
  margin-left: 10px;
  height: 350px;

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-timeline-item__node--large {
    left: 1px;
  }
  .el-timeline-item__tail {
    left: 7px;
  }

  .el-row {
    margin-bottom: 10px;

    .price{
      font-size: 15px;
    }
    .remark{
      font-size: 13px;
      color:dimgrey;
    }
  }
  
  .el-dialog{
    widows: 880px;
  }
}
.el-dialog__body{
  padding: 0px;
}
</style>